import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=396379d3&scoped=true&lang=pug&"
import script from "./Form.js?vue&type=script&lang=js&"
export * from "./Form.js?vue&type=script&lang=js&"
import style0 from "./Form.vue?vue&type=style&index=0&id=396379d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396379d3",
  null
  
)

export default component.exports